export default function ConfigureInfrastructure(){
    return <></>
}